import { useQuery } from "@tanstack/react-query";
import { useProfileContext } from "context";
import { getAIAssistantSettings } from "api/bAIAssistantApi";

export function useAIAssistantSettings() {
  const { userProfile } = useProfileContext();
  return useQuery({
    queryKey: ["ai-assistant", userProfile?.organisation_id, userProfile?.user_id, "settings"],
    queryFn: getAIAssistantSettings,
    enabled: !!userProfile?.user_id,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
